import React, { useEffect, useState } from 'react';
import { Grid, Typography, Autocomplete, TextField, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllTherapistAction,
  reAssignTherapistAction,
  resetreAssignTherapistAction,
} from 'src/redux/actions/documentationAction';
import loader from 'src/components/LoaderImg/loader.gif';
import useCurrentUser from 'src/hooks/use-current-user';

type Props = {
  close: any;
  activeTab: string;
  selectedDocument: any;
  role: string;
};

const ReAssignTherapist = (props: Props) => {
  const { close, activeTab, selectedDocument, role } = props;
  const dispatch = useDispatch();
  const getAllTherapistsResponse = useSelector((state: any) => state.getAllTherapistReducer);
  const [selectedData, setSelectedData] = useState<any>(null);
  const reAssigneResponse = useSelector((state: any) => state.reAssigntherapistReducer);
  const [_, uuid, currentRoles] = useCurrentUser(['providerId', 'uuid', 'currentRoles']);

  const handleChangeSupervisor = (e: any, value: any) => {
    setSelectedData(value);
  };

  const handleSelectSupervisor = () => {
    if (!selectedData) return;
    dispatch(reAssignTherapistAction(selectedDocument.uuid, selectedData?.uuid));
  };

  const priorityRole = (roles: string | boolean | string[] | null) => {
    if (typeof roles === 'string' || typeof roles === 'boolean' || !roles) {
      return '';
    }
    const checkRole = (role: string) => {
      return roles?.find((item) => item === role);
    };

    if (checkRole('therapist') === 'therapist') {
      return 'therapist';
    }
    if (checkRole('assistant') === 'assistant') {
      return 'assistant';
    }
    if (checkRole('student') === 'student') {
      return 'student';
    }
    if (checkRole('assistant-student') === 'assistant-student') {
      return 'assistant-student';
    }
    return roles[0];
  };

  useEffect(() => {
    dispatch(getAllTherapistAction(activeTab, priorityRole(currentRoles), uuid));
  }, []);

  useEffect(() => {
    if (!reAssigneResponse.isReAssign && reAssigneResponse.response === null) return;
    dispatch(resetreAssignTherapistAction());
    close();
  }, [reAssigneResponse]);

  return (
    <Grid sx={{ background: '#FFF', width: '725px', height: '287px' }}>
      <Grid sx={{ padding: '24px' }}>
        <Typography variant="h6">Select therapist to Re-assign</Typography>
        <Typography
          variant="body2"
          mt={1}
        >
          {activeTab}
        </Typography>
      </Grid>

      <Grid sx={{ padding: '24px' }}>
        <Autocomplete
          getOptionLabel={(option: any) => option.name}
          fullWidth
          options={getAllTherapistsResponse.response?.data}
          onChange={(e, value) => handleChangeSupervisor(e, value)}
          value={selectedData}
          disabled={
            getAllTherapistsResponse?.loading ||
            getAllTherapistsResponse.response?.data?.length === 0
          }
          renderInput={(params): JSX.Element => (
            <TextField
              {...params}
              fullWidth
              label={
                getAllTherapistsResponse.response?.data?.length === 0
                  ? 'No Records Found'
                  : `Select ${role} Name`
              }
              name="supervisor"
            />
          )}
        />
      </Grid>

      <Grid
        container
        justifyContent={'right'}
        sx={{ paddingRight: '24px' }}
      >
        <Button
          sx={{ marginRight: '8px' }}
          onClick={close}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSelectSupervisor}
          disabled={!selectedData}
        >
          {getAllTherapistsResponse.loading || reAssigneResponse.loading ? (
            <img
              src={loader}
              style={{ height: 30 }}
            />
          ) : (
            'Confirm'
          )}
        </Button>
      </Grid>
    </Grid>
  );
};

export default ReAssignTherapist;
